<template>
  <div class="map-container" v-loading="isCapturing" element-loading-text="截图中......">
    <!-- 地图 -->
    <div id="map" class="map"></div>

    <!-- 时间轴播放器 -->
    <TimelinePlayer
      v-model="timelineValue"
      :max="timelineMax"
      :marks="timelineMarks"
      :is-playing="isPlaying"
      :current-time-text="currentTimeText"
      :start-time-text="startTimeText"
      :end-time-text="endTimeText"
      :format-tooltip="formatTooltip"
      @play="handlePlay"
      @pause="handlePause"
      @change="handleTimelineChange"
      @input="handleTimelineInput"
    />

    <!-- 倍速按钮 -->
    <SpeedControl
      :options="speedOptions"
      :active-index="activeSpeedIndex"
      @change="handleSpeedChange"
    />

    <!-- 右侧菜单 -->
    <RightMenu
      :menu-list="menuList"
      :airport-visible="airportLayerVisible"
      @select="handleMenuSelect"
      @toggle-airport="toggleAirportLayer"
      @screenshot="handleScreenshot"
    />

    <!-- 云量提示 -->
    <CloudTooltip
      :cloud-info="cloudInfo"
      :cursor-tip="cursorTip"
      @close="cloudInfo.visible = false"
    />

    <!-- 加载进度蒙层 -->
    <LoadingOverlay
      :visible="showOverlay"
      :percentage="preloadPercentage"
      @close="handleCloseOverlay"
    />

    <!-- 图片预加载区域（不可见） -->
    <div class="imgboxdiv" ref="imgboxdiv" v-if="!hidePreloadImgs">
      <el-image
        v-for="(item, index) in yuntuList"
        :key="index"
        :src="item.loading ? '' : baseUrlMecn + item.file"
        @load="onImgLoadSuccess"
      />
    </div>

    <!-- 弹出对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="80%" :modal="false" draggable>
      <div class="boxnr" v-if="dialogTitle != '云图评估'">
        <el-tabs v-if="dialogTitle == '实况云图'" v-model="activeName" type="card" class="demo-tabs"
          @tab-click="handleTabClick">
          <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.name"
            :name="item.url"></el-tab-pane>
        </el-tabs>
        <div class="look-image-content">
          <div class="demo-image__preview show-image" style="height: calc(88vh - 186px)">
            <img :src="dialogImageUrl" @dblclick="handleImgDblClick" style="height: calc(88vh - 186px)"
              ref="dialogImgRef" :style="imgViewerStyle" @mousedown="imgViewer.start"
              @mouseup="imgViewer.stop" @mousemove="imgViewer.move" @mouseenter="imgViewer.mouseenter"
              @mousewheel="imgViewer.mousewheel" />
            <el-image ref="previewImageRef" style="width: 0px; height: 0px" :src="dialogImageUrl" show-progress
              :preview-src-list="srcList" fit="cover" />
          </div>
          <div class="por">
            <p @click="imgViewer.zoom('in')"><img src="./imgs/放大.png" alt="" /></p>
            <p @click="imgViewer.zoom('out')"><img src="./imgs/缩小.png" alt="" /></p>
            <p @click="imgViewer.reset()"><img src="./imgs/1_1.png" alt="" /></p>
            <p @click="imgViewer.rotate('left')"><img src="./imgs/左旋转.png" alt="" /></p>
            <p @click="imgViewer.rotate('right')"><img src="./imgs/右旋转.png" alt="" /></p>
            <p @click="handleImgDblClick"><img src="./imgs/全屏.png" alt="" /></p>
          </div>
        </div>
        <div class="shu" v-if="verticalList.length > 1">
          <div class="slider-demo-block">
            <el-slider v-model="verticalValue" vertical :format-tooltip="formatVerticalTooltip"
              :max="verticalMax" :marks="verticalMarks" height="40vh" @input="handleVerticalInput" />
          </div>
        </div>
      </div>
      <div v-else style="height: calc(88vh - 136px)">
        <el-tabs v-model="activeEvalRegion" type="card" class="demo-tabs" @tab-click="handleEvalRegionClick">
          <el-tab-pane v-for="(item, index) in evalRegions" :key="index" :label="item.nameclick"
            :name="item.type"></el-tab-pane>
        </el-tabs>
        <el-row>
          <el-col :span="item.type" v-for="(item, index) in pingguList" :key="index">
            <div class="grid-content ep-bg-purple" v-show="item.item !== '5'">
              <div class="rid-box">
                <div class="bgcimgday">{{ item.day }}</div>
                <div class="bgcimgname" :style="item.item == '0' ? 'width: 190px;left: calc(50% - 95px);' : ''">
                  {{ item.name }}
                </div>
                <div class="bgcimg" :style="item.bgcimgstyle ? item.bgcimgstyle : item.bgcimgstyle_">
                  <canvas :style="item.canvasstyle ? item.canvasstyle : item.canvasstyle_"
                    :id="'myCanvas' + index" width="500" height="300"></canvas>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <template #footer>
        <div class="poa">
          <div style="height: 80px">
            <div class="footer1" v-if="dialogMax > 1">{{ dialogTimeText(0) }}</div>
            <div class="footer2" v-if="dialogMax > 1">{{ dialogTimeText(1) }}</div>
            <div class="footer3" v-if="dialogMax > 1">{{ dialogTimeText(2) }}</div>
            <div class="slider-demo-block-box" v-if="dialogMax > 1">
              <span class="demonstration">
                <div class="imgBox">
                  <img v-if="dialogPlaying" src="./imgs/pause.png" alt="" @click.stop="handleDialogPause" />
                  <img v-else src="./imgs/play.png" alt="" @click="handleDialogPlay" />
                </div>
              </span>
              <el-slider v-model="dialogValue" :step="1" :max="dialogMax" :marks="dialogMarks" :key="dialogMax"
                class="sli" @change="handleDialogChange" @input="handleDialogInput"
                :format-tooltip="formatDialogTooltip" :tooltip-class="'custom-tooltip'" />
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';

// 组件
import TimelinePlayer from '@/components/timeline/TimelinePlayer.vue';
import SpeedControl from '@/components/timeline/SpeedControl.vue';
import RightMenu from '@/components/sidebar/RightMenu.vue';
import CloudTooltip from '@/components/map/CloudTooltip.vue';
import LoadingOverlay from '@/components/overlay/LoadingOverlay.vue';

// Composables
import { useMapInit } from '@/composables/useMapInit';
import { useCloudOverlay } from '@/composables/useCloudOverlay';
import { useScreenshot } from '@/composables/useScreenshot';
import { useImageViewer } from '@/composables/useImageViewer';
import { useResponsive } from '@/composables/useResponsive';
import { computeMainMarks, computeDialogMarks, findCurrentTimeIndex } from '@/composables/useTimelineMarks';

// 配置
import { BASE_URL, BASE_URL_MECN } from '@/config/map.config';
import { MENU_LIST, SPEED_OPTIONS, TAB_LIST, EVAL_REGIONS, createInitialPingguList } from '@/config/menu.config';

// ======================== 地图初始化 ========================
const { map, airportLayerVisible, initMap, toggleAirportLayer } = useMapInit();
const { cloudInfo, cursorTip, renderCloud } = useCloudOverlay(map);
const { takeScreenshot, isCapturing } = useScreenshot(map);
const imgViewer = useImageViewer();
const { isMobile, screenWidth } = useResponsive();

// ======================== 基础数据 ========================
const baseUrlMecn = BASE_URL_MECN;
const menuList = ref(JSON.parse(JSON.stringify(MENU_LIST)));
const speedOptions = ref(SPEED_OPTIONS);
const tabList = ref(TAB_LIST);
const evalRegions = ref(EVAL_REGIONS);
const activeSpeedIndex = ref(1);
const speed = ref(500);

// ======================== 主时间轴 ========================
const timelineValue = ref(0);
const timelineMax = ref(0);
const timelineMarks = ref({});
const isPlaying = ref(false);
const intervalId = ref(null);
const yuntuList = ref([]);

// ======================== 图片预加载 ========================
const hidePreloadImgs = ref(true);
const showOverlay = ref(false);
const preloadPercentage = ref(0);
const readyNum = ref(0);
const needPreload = ref(true);

// ======================== 弹窗相关 ========================
const dialogVisible = ref(false);
const dialogTitle = ref('');
const dialogImageUrl = ref('');
const srcList = ref([]);
const activeName = ref('FY4B');
const dialogValue = ref(0);
const dialogMax = ref(0);
const dialogMarks = ref({});
const dialogPlaying = ref(false);
const dialogIntervalId = ref(null);
const dialogDataList = ref([]);
const previewImageRef = ref(null);
const dialogImgRef = ref(null);
const imgViewerStyle = computed(() => imgViewer.styleObj.value);

// 竖向滑块
const verticalList = ref([]);
const verticalValue = ref(0);
const verticalMax = ref(0);
const verticalMarks = ref({});

// 云图评估
const activeEvalRegion = ref('1');
const pingguList = ref(createInitialPingguList());

// ======================== 时间文本计算 ========================
const currentTimeText = computed(() => {
  if (!yuntuList.value.length) return '';
  const idx = Math.max(0, timelineValue.value);
  return yuntuList.value[idx]?.fileDesc || '';
});

const startTimeText = computed(() => {
  if (!yuntuList.value.length) return '';
  return (yuntuList.value[0]?.fileDesc || '').substring(8, 17);
});

const endTimeText = computed(() => {
  if (!yuntuList.value.length) return '';
  return (yuntuList.value[yuntuList.value.length - 1]?.fileDesc || '').substring(8, 17);
});

const formatTooltip = (val) => {
  return yuntuList.value[val]?.fileDesc || '';
};

// ======================== 弹窗时间文本 ========================
const dialogTimeText = (type) => {
  if (!dialogDataList.value.length) return '';
  if (type === 0) {
    const idx = Math.max(0, dialogValue.value);
    return dialogDataList.value[idx]?.fileDesc || '';
  }
  const idx = type === 1 ? 0 : dialogDataList.value.length - 1;
  return (dialogDataList.value[idx]?.date || '').substring(5, 16);
};

const formatDialogTooltip = (val) => {
  return dialogDataList.value[val]?.fileDesc || '';
};

const formatVerticalTooltip = (val) => {
  return verticalList.value[val]?.pub_param - 0 + '米';
};

// ======================== 播放控制 ========================
const handlePlay = () => {
  if (needPreload.value) {
    // 首次播放需要预加载
    yuntuList.value.forEach((item, index) => {
      yuntuList.value[index].loading = false;
    });
    needPreload.value = false;
    hidePreloadImgs.value = false;
    showOverlay.value = true;
  } else {
    startPlay();
  }
};

const startPlay = () => {
  isPlaying.value = true;
  clearInterval(intervalId.value);
  intervalId.value = setInterval(() => {
    timelineValue.value++;
    if (timelineValue.value >= yuntuList.value.length - 1) {
      timelineValue.value = 0;
    }
    renderCloud(BASE_URL_MECN + yuntuList.value[timelineValue.value].file);
  }, speed.value);
};

const handlePause = () => {
  isPlaying.value = false;
  clearInterval(intervalId.value);
};

const handleTimelineChange = () => {
  handlePause();
};

const handleTimelineInput = (val) => {
  if (yuntuList.value.length > 0) {
    renderCloud(BASE_URL_MECN + yuntuList.value[val].file);
  }
};

const onImgLoadSuccess = () => {
  readyNum.value++;
  preloadPercentage.value = Math.round((readyNum.value / yuntuList.value.length) * 100);
  if (readyNum.value >= yuntuList.value.length) {
    showOverlay.value = false;
    startPlay();
  }
};

const handleCloseOverlay = () => {
  needPreload.value = true;
  showOverlay.value = false;
  readyNum.value = 0;
  preloadPercentage.value = 0;
};

// ======================== 倍速控制 ========================
const handleSpeedChange = (index) => {
  activeSpeedIndex.value = index;
  speed.value = SPEED_OPTIONS[index].sd;
  clearInterval(intervalId.value);
  if (isPlaying.value) startPlay();
};

// ======================== 截图 ========================
const handleScreenshot = () => {
  takeScreenshot(`地图截图_${currentTimeText.value}`);
};

// ======================== 右侧菜单 ========================
const handleMenuSelect = (index) => {
  // 切换菜单前停止播放
  if (readyNum.value < yuntuList.value.length) {
    yuntuList.value.forEach((item, i) => { yuntuList.value[i].loading = true; });
    needPreload.value = true;
    readyNum.value = 0;
    showOverlay.value = false;
    preloadPercentage.value = 0;
  }
  handlePause();

  // 重置弹窗状态
  imgViewer.reset();
  dialogValue.value = 0;
  verticalValue.value = 0;
  verticalMax.value = 0;
  dialogMax.value = 0;
  activeName.value = 'FY4B';
  dialogImageUrl.value = '';
  dialogPlaying.value = false;
  verticalMarks.value = {};
  dialogMarks.value = {};
  verticalList.value = [];
  srcList.value = [];
  clearInterval(dialogIntervalId.value);

  // 更新菜单激活状态
  menuList.value.forEach((item, i) => {
    item.lfag = index === i ? 'itembgc1' : 'item';
  });

  dialogTitle.value = menuList.value[index].name;

  if (dialogTitle.value === '云图评估') {
    runEvaluation(evalRegions.value[0]);
  }

  dialogVisible.value = true;

  if (menuList.value[index].name === '实况云图') {
    fetchDialogData(BASE_URL + menuList.value[index].url + activeName.value + '/list.json', activeName.value + '/');
  } else if (menuList.value[index].url) {
    fetchDialogData(BASE_URL + menuList.value[index].url + 'list.json');
  }
};

// ======================== 弹窗数据获取 ========================
const fetchDialogData = async (url, pathPrefix) => {
  try {
    const timestamp = new Date().getTime();
    const res = await axios.get(`${url}?${timestamp}`);
    const data = res.data.datalist[0].list;
    dialogMax.value = data.length - 1;
    dialogDataList.value = data;
    dialogMarks.value = computeDialogMarks(data, screenWidth.value, dialogTitle.value);
    srcList.value = data.map(r => {
      const urls = menuList.value.find(f => f.name === dialogTitle.value)?.url || '';
      return pathPrefix ? BASE_URL + urls + pathPrefix + r.file : BASE_URL + urls + r.file;
    });
    if (res.data.datalist.length > 1) {
      verticalList.value = res.data.datalist;
      verticalMax.value = res.data.datalist.length - 1;
      const type = dialogTitle.value === '云量预报' ? '米' : 'Hpa';
      const marks = {};
      res.data.datalist.forEach((item, idx) => { marks[idx] = item.pub_param - 0 + type; });
      verticalMarks.value = marks;
    }
    // 定位到当前时间
    const idx = findCurrentTimeIndex(data);
    dialogValue.value = idx;
    updateDialogImage();
  } catch (error) {
    console.error('获取数据失败:', error);
    ElMessage.error('数据加载失败');
  }
};

const updateDialogImage = () => {
  const urls = menuList.value.find(f => f.name === dialogTitle.value)?.url || '';
  if (dialogTitle.value === '实况云图') {
    dialogImageUrl.value = BASE_URL + urls + activeName.value + '/' + dialogDataList.value[dialogValue.value]?.file;
  } else {
    dialogImageUrl.value = BASE_URL + urls + dialogDataList.value[dialogValue.value]?.file;
  }
};

// ======================== 弹窗播放控制 ========================
const handleDialogPlay = () => {
  dialogPlaying.value = true;
  clearInterval(dialogIntervalId.value);
  dialogIntervalId.value = setInterval(() => {
    dialogValue.value = dialogValue.value >= dialogDataList.value.length - 1 ? 0 : dialogValue.value + 1;
    updateDialogImage();
  }, speed.value);
};

const handleDialogPause = () => {
  dialogPlaying.value = false;
  clearInterval(dialogIntervalId.value);
};

const handleDialogChange = () => { handleDialogPause(); };
const handleDialogInput = (val) => { dialogValue.value = val; updateDialogImage(); };

// ======================== 弹窗 Tab 切换 ========================
const handleTabClick = (tab, event) => {
  const url = tabList.value.find(f => f.name === event.target.innerText)?.url;
  const urls = menuList.value.find(f => f.name === dialogTitle.value)?.url;
  fetchDialogData(BASE_URL + urls + url + '/list.json', url + '/');
};

// ======================== 竖向滑块 ========================
const handleVerticalInput = (v) => {
  dialogDataList.value = verticalList.value[v].list;
  updateDialogImage();
};

// ======================== 图片双击预览 ========================
const handleImgDblClick = () => {
  previewImageRef.value?.showPreview();
};

// ======================== 云图评估 ========================
const handleEvalRegionClick = (tab, event) => {
  const region = evalRegions.value.find(f => f.nameclick === event.target.innerText);
  if (region) runEvaluation(region);
};

const runEvaluation = (region) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = now.getHours();
  const horList = ['02', '08', '14', '20'];

  let hossIdx = horList.findIndex(f => f - 0 > hours - 0.5);
  if (hossIdx === -1 || hours <= 2) hossIdx = 3;
  else hossIdx = hossIdx - 1;
  const hoss = horList[hossIdx];

  const nameUrl = 'MERCATOR_';
  const Listdata = [5, 9, 0, 1, 2, 3, 11, 12, 13, 14, 7];

  for (let i = 1; i < 12; i++) {
    let aday, amonth, ayear = year;
    const dayNum = parseInt(day);
    if (dayNum - i >= 1) {
      aday = String(dayNum - i).padStart(2, '0');
      amonth = month;
    } else {
      amonth = String(parseInt(month) - 1).padStart(2, '0');
      if (amonth === '00') { amonth = '12'; ayear = year - 1; }
      const daysInMonth = new Date(ayear, parseInt(amonth), 0).getDate();
      aday = String(daysInMonth + (dayNum - i)).padStart(2, '0');
    }

    const itemUrl = `${nameUrl}${ayear}${amonth}${aday}20_${year}${month}${day}00${hoss}00.PNG`;

    if (Listdata[i - 1] !== 7) {
      pingguList.value[Listdata[i - 1]].day = 'day' + i;
      pingguList.value[Listdata[i - 1]].urla = pingguList.value[Listdata[i - 1]].url + itemUrl;
      pingguList.value[Listdata[i - 1]].name = `${aday}日20时生成${month}月${day}日${hoss}时AI云图`;
      Object.assign(pingguList.value[Listdata[i - 1]], {
        x: region.x, y: region.y, width: region.width, height: region.height,
        bgcimgstyle: { ...region.bgcimgstyle },
        canvasstyle: { ...region.canvasstyle },
      });
    } else {
      const ho = hoss - 8 >= 10 ? hoss - 8 : '0' + (hoss - 8);
      pingguList.value[Listdata[i - 1]].urla =
        BASE_URL + `yuntu/fy2gPic/FY2G_${year}_${month}_${day}_${ho}_01_L_PJ1_Pic.JPG`;
      pingguList.value[Listdata[i - 1]].name = `${month}月${day}日${hoss}时实况云图`;
      pingguList.value[Listdata[i - 1]].day = 'day0';
      Object.assign(pingguList.value[Listdata[i - 1]], {
        x: region.x_, y: region.y_, width: region.width_, height: region.height_,
        bgcimgstyle_: { ...region.bgcimgstyle },
        canvasstyle_: {
          top: region.nameclick === '西南' ? region.canvasstyle_.top : region.canvasstyle.top,
          left: region.nameclick === '西南' ? region.canvasstyle_.left : region.canvasstyle.left,
          width: region.nameclick === '西南' ? region.canvasstyle_.width : region.canvasstyle.width,
          position: region.nameclick === '西南' ? region.canvasstyle_.position : region.canvasstyle.position,
        },
      });
    }
  }

  nextTick(() => {
    pingguList.value.forEach((item, index) => {
      cropImage('myCanvas' + index, item.urla, item.x, item.y, item.width, item.height);
    });
  });
};

const cropImage = (id, imageSrc, x, y, width, height) => {
  const canvas = document.getElementById(id);
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const image = new Image();
  image.crossOrigin = 'Anonymous';
  image.onload = function () {
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(image, x, y, width, height, 0.5, 0.5, width, height);
  };
  image.src = imageSrc;
};

// ======================== 初始化 ========================
const initData = async () => {
  try {
    const timestamp = new Date().getTime();
    const res = await axios.get(`${BASE_URL_MECN}list.json?${timestamp}`);
    timelineMax.value = res.data.datalist[0].list.length - 1;
    yuntuList.value = res.data.datalist[0].list;
    timelineMarks.value = computeMainMarks(res.data.datalist[0].list, screenWidth.value);
    // 定位到当前时间
    const idx = findCurrentTimeIndex(res.data.datalist[0].list);
    timelineValue.value = idx;
    renderCloud(BASE_URL_MECN + yuntuList.value[idx].file);
  } catch (error) {
    console.error('初始数据加载失败:', error);
  }
};

onMounted(() => {
  initMap();
  initData();
});

onBeforeUnmount(() => {
  clearInterval(intervalId.value);
  clearInterval(dialogIntervalId.value);
});
</script>

<style lang="less" scoped>
.map-container {
  width: 100%;
  height: 100vh;
}

.map {
  width: 100%;
  height: 100%;
}

#map {
  background-color: #0b0f39;
}

.imgboxdiv {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: fixed;
  bottom: 0;

  img { width: 10px; height: 10px; }
}
</style>

<style scoped>
@import "leaflet/dist/leaflet.css";

:deep(.el-dialog) {
  margin: 66px auto 0 auto !important;
}

:deep(.airport-label) {
  background: rgba(11, 15, 57, 0.65);
  border: 1px solid #4ed7ff;
  border-radius: 4px;
  color: #4ed7ff;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  white-space: nowrap;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}

:deep(.airport-label)::before {
  display: none;
}

:deep(.province-label) {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

:deep(.province-label span) {
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.8), 0 1px 2px rgba(0, 0, 0, 0.6);
  pointer-events: none;
}

:deep(.city-label) {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

:deep(.city-label span) {
  color: #b8e0ff;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.8), 0 1px 2px rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

:deep(.cloud-overlay) {
  cursor: default !important;
}

:deep(.leaflet-interactive.cloud-overlay) {
  cursor: default !important;
}
</style>

<style lang="less" scoped>
/* 弹窗相关样式 */
.look-image-content {
  position: relative;

  .show-image img {
    height: 100%;
    position: relative;
    top: 0;
    left: 0;
  }

  .por {
    position: absolute;
    width: 50px;
    top: 30px;
    left: 30px;
    padding: 0;
    margin: 0;

    p {
      cursor: pointer;
      margin: 15px 0;
      width: 20px;
      height: 20px;
      padding: 5px;
      background-color: hsl(204, 100%, 50%);

      img { width: 20px; height: 20px; }
    }
  }
}

.demo-image__preview {
  border: 1px solid red;
  overflow: hidden;
}

.shu {
  .slider-demo-block {
    max-width: 60px;
    display: flex;
    position: fixed;
    right: 30vh;
    top: 0vh;
    bottom: 80px;
    z-index: 1207;
    align-items: center;

    .el-slider {
      margin-top: 0;
      margin-left: 12px;
    }
  }
}

.poa {
  width: 100%;
  height: 80px;
  position: relative;
}

.footer1 {
  cursor: pointer;
  position: absolute;
  bottom: 120px;
  right: calc(50% - 140px);
  z-index: 999;
  padding: 5px 15px;
  border-radius: 20px;
  text-align: center;
  color: #fff;
  background-color: #0b0f3960;

  &:hover { background-color: #0b0f39; }
}

.footer2 {
  cursor: pointer;
  position: absolute;
  bottom: 0px;
  left: 0%;
  z-index: 999;
  padding: 5px 15px;
  border-radius: 20px;
  text-align: center;
  color: #fff;
  background-color: #0b0f3960;

  &:hover { background-color: #0b0f39; }
}

.footer3 {
  position: absolute;
  cursor: pointer;
  bottom: 0px;
  right: 0%;
  z-index: 999;
  padding: 5px 15px;
  border-radius: 20px;
  text-align: center;
  color: #fff;
  background-color: #0b0f3960;

  &:hover { background-color: #0b0f39; }
}

.slider-demo-block-box {
  width: 95%;
  display: flex;
  align-items: center;
  position: relative;
  top: 0px;

  .el-slider { margin-top: 0; margin-left: 12px; }

  .demonstration {
    font-size: 14px;
    color: var(--el-text-color-secondary);
    line-height: 44px;
    flex: 0.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 0;
  }

  .demonstration + .el-slider { flex: 1 0 70%; }
}

.imgBox {
  margin: 0 auto;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;

  img { width: 30px; height: 30px; }
}

/* 云图评估 */
.el-row:last-child { margin-bottom: 0; }

.grid-content {
  width: 100%;
  height: 100%;
  background-color: #0b0f39;
  border-radius: 4px;
  min-height: 36px;
}

.el-col {
  padding: 5px;
  height: calc(29vh - 32px);
  border-radius: 4px;
  box-sizing: border-box;
}

.rid-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.bgcimgname {
  position: relative;
  top: 82%;
  left: calc(50% - 160px);
  font-size: 18px;
  box-sizing: border-box;
  background-color: #0b0f3970;
  border-radius: 10px;
  width: 300px;
  z-index: 1000;
  font-family: 楷体;
  font-weight: 900;
  color: #fff;
}

.bgcimgday {
  position: relative;
  top: 0;
  font-size: 18px;
  background-color: #0b0f3970;
  border-radius: 10px;
  width: 60px;
  z-index: 1000;
  font-family: 楷体;
  font-weight: 900;
  color: #fff;
}

.bgcimg {
  background-image: url("./imgs/bj.jpg");
  transform: scale(0.9);
  width: calc(1089.2px * 0.8);
  height: calc(913.734px * 0.8);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;

  canvas {
    width: calc(1089.2px * 0.35);
    position: relative;
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .map-container { width: 100vw; height: 100vh; overflow: hidden; }

  :deep(.el-dialog) { width: 96% !important; margin: 50px auto 0 auto !important; }
  :deep(.el-dialog__header) { padding: 10px 12px !important; }
  :deep(.el-dialog__title) { font-size: 14px !important; }
  :deep(.el-dialog__body) { padding: 8px !important; }
  :deep(.demo-tabs .el-tabs__item) { padding: 0 8px !important; font-size: 12px !important; }

  .look-image-content {
    .show-image img { height: calc(60vh) !important; }
    .por { width: 36px; top: 8px; left: 8px;
      p { margin: 8px 0; width: 16px; height: 16px; padding: 4px;
        img { width: 16px; height: 16px; }
      }
    }
  }

  .demo-image__preview.show-image { height: calc(60vh) !important; }
  .bgcimg { transform: scale(0.5) !important; transform-origin: top left; }
  .bgcimgname { font-size: 12px; width: 200px; left: calc(50% - 100px); }
  .bgcimgday { font-size: 12px; width: 40px; }
  .el-col { height: calc(28vh - 16px); padding: 2px; }

  .footer1 { bottom: 90px; right: calc(50% - 90px); font-size: 12px; padding: 3px 10px; }
  .footer2, .footer3 { font-size: 11px; padding: 3px 8px; }
  .slider-demo-block-box { width: 100%; }

  :deep(.airport-label) { font-size: 9px; padding: 1px 4px; }
  :deep(.leaflet-control-zoom) { font-size: 14px; }
  :deep(.leaflet-control-zoom a) { width: 28px !important; height: 28px !important; line-height: 28px !important; }
}
</style>
